import paymentPage from '@/components/common/gcr/raffle/dnaPaymentModal.vue';
import rafflePage from '@/views/Templates/gcr/rafflePage.vue';
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "landingPage",
    component: () => import("@/views/main.vue"),
  },
  {
    path: "/raffle",
    name: "rafflePage",
    component: rafflePage,
  },
  {
    path: "/payments",
    name: "paymentsPage",
    component: paymentPage,
  },
  {
    path: "/paymentFailure",
    name: "PaymentFailure",
    component: function () {
      return import("../views/paymentFailureNew.vue");
    },
  },
  {
    path: "/paymentSuccess",
    name: "PaymentSuccess",
    component: function () {
      return import("../views/paymentSuccessNew.vue");
    },
  },
  {
    path: "/stripeCheckout",
    name: "StripeCheckout",
    component: function () {
      return import("../views/stripePayment/stripeCheckout.vue");
    },
  },
  {
    path: "/pageNotFound",
    name: "pageNotFound",
    component: () => import("@/views/Templates/reference/pageNotFoundPage.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
